import * as React from "react";
const NewsSearch = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.16663 0.208252C4.67931 0.208252 1.04163 3.84594 1.04163 8.33325C1.04163 12.8206 4.67931 16.4583 9.16663 16.4583C13.6539 16.4583 17.2916 12.8206 17.2916 8.33325C17.2916 3.84594 13.6539 0.208252 9.16663 0.208252ZM2.29163 8.33325C2.29163 4.53629 5.36967 1.45825 9.16663 1.45825C12.9636 1.45825 16.0416 4.53629 16.0416 8.33325C16.0416 12.1302 12.9636 15.2083 9.16663 15.2083C5.36967 15.2083 2.29163 12.1302 2.29163 8.33325Z"
      fill={props.fill}
    />
    <path
      d="M16.2753 14.5581C16.0312 14.314 15.6355 14.314 15.3914 14.558C15.1473 14.8021 15.1473 15.1979 15.3914 15.4419L18.7246 18.7752C18.9687 19.0193 19.3645 19.0193 19.6085 18.7752C19.8526 18.5312 19.8526 18.1354 19.6085 17.8913L16.2753 14.5581Z"
      fill={props.fill}
    />
  </svg>
);
export default NewsSearch;
